module.exports = __webpack_public_path__ + "static/media/BB.2b57e84a.svg";